module.exports = __webpack_public_path__ + "static/media/education-road-clear.ad3b8995.png";